module.exports = __webpack_public_path__ + "media/images/new/roadpass-inline-logo-ba80646dd9ac9c64c94e7c30a8114d09.png";